'use strict';

var React = require('react');

var SvgPhoneInIcon = function SvgPhoneInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.751 3c-2.03 0-3.861 1.681-3.527 3.855.42 2.737 1.442 5.012 3.12 6.715 1.68 1.705 3.962 2.78 6.801 3.216 2.174.334 3.854-1.497 3.854-3.527v-.727a1.75 1.75 0 0 0-1.306-1.693l-1.9-.498a1.75 1.75 0 0 0-1.276.153l-1.067.576c-.352.19-.663.165-.85.034a7.184 7.184 0 0 1-1.694-1.71c-.133-.192-.155-.509.036-.86l.572-1.05.001-.002c.211-.39.266-.846.153-1.276l-.498-1.9a1.75 1.75 0 0 0-1.693-1.306h-.726Zm-2.045 3.627c-.169-1.102.76-2.127 2.045-2.127h.726a.25.25 0 0 1 .242.187l.498 1.9a.252.252 0 0 1-.022.182l-.57 1.047c-.378.693-.496 1.64.045 2.428a8.678 8.678 0 0 0 2.071 2.09c.784.548 1.731.429 2.422.056l1.067-.576a.25.25 0 0 1 .182-.022l1.9.498a.25.25 0 0 1 .187.242v.727c0 1.284-1.025 2.213-2.126 2.044-2.587-.397-4.55-1.356-5.96-2.786-1.41-1.431-2.323-3.392-2.707-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.749 9.01a.75.75 0 0 0 0-1.5h-1.19l2.72-2.72a.75.75 0 0 0-1.06-1.06l-2.72 2.72v-1.19a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3Z"
  }));
};
SvgPhoneInIcon.displayName = "PhoneInIcon";

exports.SvgPhoneInIcon = SvgPhoneInIcon;
